module.exports = __webpack_public_path__ + "ad2fed42ce2ec7984401d64a42444ddd.png";